import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const CardGamesIconColored: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" className={props.className} width="22" height="22.592" viewBox="0 0 22 22.592">
		<g transform="translate(-1.463 0.047)">
			<rect width="13.019" height="20.329" rx="2" transform="matrix(0.978, 0.208, -0.208, 0.978, 10.729, -0.047)" fill="#b7b7b7" />
			<path
				d="M86.316,128.883a2.084,2.084,0,0,0-1.4.538,2.084,2.084,0,0,0-3.481,1.552,2.9,2.9,0,0,0,.686,1.736l2.417,3.466a.483.483,0,0,0,.793,0l2.383-3.447a2.929,2.929,0,0,0,.682-1.755h0A2.084,2.084,0,0,0,86.316,128.883Z"
				transform="matrix(0.966, 0.259, -0.259, 0.966, -32.709, -138.84)"
				fill="red"
			/>
			<path d="M2,0H12.5a2,2,0,0,1,2,2V18.329a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z" transform="translate(1.463 -0.047)" fill="#fff" />
			<g transform="translate(0.561 0.475)">
				<path
					d="M-15.564-26.593a2.235,2.235,0,0,1-2.067,1.127A2.054,2.054,0,0,1-19.2-28.342c.465-1.385,3.633-4.309,3.633-4.309s3.177,2.968,3.636,4.309.084,2.518-1.437,2.876A1.988,1.988,0,0,1-15.564-26.593Z"
					transform="translate(23.697 38.179)"
				/>
				<path
					d="M-4.646-9.7c-.023-.07,0-1.564,0-1.564"
					transform="translate(12.714 23.02)"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeWidth="1"
				/>
			</g>
		</g>
	</svg>
);
